$(function() {

  function countDecimals(number) {
      if(Math.floor(number.valueOf()) === number.valueOf()) return 0;
      if (number.toString().indexOf(".") === -1) return 0;
      return number.toString().split(".")[1].length || 0; 
  }

  $("label[for=quantity_1]").show();
  $("label[for=quantity_2]").show();
  $("label[for=quantity_4]").show();
  $("label[for=quantity_20]").hide();
  $("label[for=quantity_50]").hide();
  $("label[for=quantity_100]").hide();


  function showHideFAQS(seIndex) {
    $("#subscription_0").css("display", "none");
    $("#subscription_1").css("display", "none");
    $("#subscription_2").css("display", "none");
    $("#subscription_3").css("display", "none");

    let selector = "#subscription_" + seIndex;

    $(selector).css("display", "block");
  }

  showHideFAQS(0);

  $("#subs-flick-back").hide();

  let $subSlider = $("#options-slider").flickity({
    accessibility: false,
    // cellAlign: 'center',
    percentPosition: false,
    // resize: false,
    adaptiveHeight: true,
    prevNextButtons: false,
    cellSelector: '.options-container',
    draggable: false,
  });


  let flkty = $subSlider.data('flickity');

  let coffeeType;
  let grind;
  let quantity;
  let frequency;
  let shipping;

  $("#options-slider").on("click", ":radio", function() {

    if ($(this).val() == "Capsule" || $(this).val() == "Espresso") {
      // Skip right to the frequency option
      $("#options-slider").flickity("selectCell", 2);
    } else {
      $("#options-slider").flickity("next");
    }

    // Set the options on the last page

    coffeeType = $("input[name=attribute_type]:checked").val(); 
    grind = $("input[name=attribute_grind]:checked").val();
    quantity = $("input[name=attribute_quantity]:checked").val();
    frequency = $("input[name=attribute_frequency]:checked").val();
    shipping = $("input[name=shipping_estimate]:checked").val();

    if (coffeeType == "Espresso") {
      // Select Wholebean

      grind = "Wholebean";

      $("input[type=radio]#grind_Wholebean").prop("checked", true);


    } else if (coffeeType == "Capsule") {
      grind = " - ";

      $("input[type=radio]#grind_Wholebean").prop("checked", true);

    }

    // Change the quantity text on the summary page

    let quantityText = "";

    if (quantity == 1 || quantity == 20) {

      if (coffeeType == "Capsule") {
        quantityText = "20 Capsules";
      } else {
        quantityText = "1 x 250g";
      }

    } else if (quantity == 2 || quantity == 50) {

      if (coffeeType == "Capsule") {
        quantityText = "50 Capsules";
      } else {
        quantityText = "2 x 250g";
      }

    } else if (quantity == 4 || quantity == 100) {

      if (coffeeType == "Capsule") {
        quantityText = "100 Capsules";
      } else {
        quantityText = "4 x 250g";
      }

    }

    // Set the quantity and frequency labels to be correct.

    if (coffeeType == "Capsule") {


      $("label[for=quantity_1]").hide();
      $("label[for=quantity_2]").hide();
      $("label[for=quantity_4]").hide();
      $("label[for=quantity_20]").show();
      $("label[for=quantity_50]").show();
      $("label[for=quantity_100]").show();

      $(".options-container[data-attribute-name=Quantity]").find("h3").each(function() {

        let newString = $(this).text().replace("1 x 250g", "20 Capsules");
        newString = newString.replace("2 x 250g", "50 Capsules");
        newString = newString.replace("4 x 250g", "100 Capsules");
        $(this).text(newString);
      });

    } else {

      $("label[for=quantity_1]").show();
      $("label[for=quantity_2]").show();
      $("label[for=quantity_4]").show();
      $("label[for=quantity_20]").hide();
      $("label[for=quantity_50]").hide();
      $("label[for=quantity_100]").hide();

      $(".options-container[data-attribute-name=Quantity]").find("h3").each(function() {

        let newString = $(this).text().replace("20 Capsules", "1 x 250g");
        newString = newString.replace("50 Capsules", "2 x 250g");
        newString = newString.replace("100 Capsules", "4 x 250g");
        $(this).text(newString);
      });
    }

    let zoneName = $("input[name=shipping_estimate]:checked").attr("data-shipping-zone-name");
    let zoneCost = $("input[name=shipping_estimate]:checked").attr("data-shipping-cost");

    let includeCost = "INCLUDES £" + zoneCost + " POSTAGE TO " + zoneName;

    if (coffeeType == "Capsule") {
      coffeeType = "Capsule";
    }

    $("#sub-summary-coffee-type").text(coffeeType);
    $("#sub-summary-coffee-weight").text(grind);
    $("#sub-summary-coffee-frequency").text(quantityText);
    $("#summary-postage").text(includeCost);

    get_sub_price(); 


    window.scrollTo(0,0);

  });

  function get_sub_price() {

    let price = 0;

    if (coffeeType == "Capsule") {

      if (quantity == "20") {
        let $label = $("label[for=quantity_20]");
        price = $label.find("#quantity-pod-cost").val();
      } else if (quantity == "50") {
        let $label = $("label[for=quantity_50]");
        price = $label.find("#quantity-pod-cost").val();
      } else if (quantity == "100") {
        let $label = $("label[for=quantity_100]");
        price = $label.find("#quantity-pod-cost").val();
      }

    } else {

      if (quantity == "1") {
        let $label = $("label[for=quantity_1]");
        price = $label.find("#quantity-filter-cost").val();
      } else if (quantity == "2") {
        let $label = $("label[for=quantity_2]");
        price = $label.find("#quantity-filter-cost").val();
      } else if (quantity == "4") {
        let $label = $("label[for=quantity_4]");
        price = $label.find("#quantity-filter-cost").val();
      } else {
      }

    }

    if (countDecimals(price) == 1) {
      price = price + "0"
    }

    let fullString = "£" + price + " " + frequency + " PAYMENT";

    

    $("#sub_product_price").text(fullString.toUpperCase());

    $(".options-container[data-attribute-name=Frequency]").find(".option-subtitle").each(function() {

      let subString = "£" + price;

      if (countDecimals(price) == 1) {
        subString = subString + "0"
      }

      $(this).text(subString);

    });

  } 

  function get_sub_price_ajax() {

    let subProductId = $("form").attr("data-product_id");

    $.ajax({
      type: "POST",
      url: loading_vars.ajaxurl,
      data: {
        'action':  "get_subscription_price",
        'coffee' : coffeeType,
        'grind' : grind,
        'frequency' : frequency,
        'quantity' : quantity,
        'product_id' : subProductId
      },
      success: function (response) {

        let fullString = "£" + response + " " + frequency + " PAYMENT";

        $("#sub_product_price").text(fullString.toUpperCase());

        $(".options-container[data-attribute-name=Frequency]").find(".option-subtitle").each(function() {

          let subString = "£" + response;

          $(this).text(subString);

        });

      }
    });
  }

  let $backText = $("subs-flick-back-text");

  // Status:
  // 0 - Incomplete
  // 1 - Currently selected
  // 2 - Completed
  function setCircleStatus($selector, status) {

    switch(status) {
      case 0:
        $selector.find("#cir-complete").addClass("circle-img-hide");
        $selector.find("#cir-incomplete").removeClass("circle-img-hide");
        $selector.find("#cir-current").addClass("circle-img-hide");
        break;
      case 1:
        $selector.find("#cir-complete").addClass("circle-img-hide");
        $selector.find("#cir-incomplete").addClass("circle-img-hide");
        $selector.find("#cir-current").removeClass("circle-img-hide");
        break;
      case 2:
        $selector.find("#cir-complete").removeClass("circle-img-hide");
        $selector.find("#cir-incomplete").addClass("circle-img-hide");
        $selector.find("#cir-current").addClass("circle-img-hide");
        break;
      default:
        break;
    }

  }

  $subSlider.on("select.flickity", function() {

    // Change the progress circles

    $("#wholebean-notice").css("display", "block");
    $("#faq-section").css("display", "block");




    showHideFAQS(flkty.selectedIndex);

    switch(flkty.selectedIndex) {
      case 0:
        // Coffee
        setCircleStatus($("#progress-cir-coffee"), 1);
        setCircleStatus($("#progress-cir-quantity"), 0);
        setCircleStatus($("#progress-cir-frequency"), 0);
        setCircleStatus($("#progress-cir-shipping"), 0);

        $("#subs-title").text("YOUR COFFEE");
        $("#subs-subtitle").text("HOW DO YOU MAKE YOUR COFFEE?");
        $("#subs-flick-back").hide();

        break;
      case 1:
        setCircleStatus($("#progress-cir-coffee"), 2);
        setCircleStatus($("#progress-cir-quantity"), 1);
        setCircleStatus($("#progress-cir-frequency"), 0);
        setCircleStatus($("#progress-cir-shipping"), 0);

        $("#subs-title").text("GRIND");
        $("#subs-subtitle").text("SELECT GRIND PROFILE");
        $("#subs-flick-back").show();


        break;
      case 2:
        setCircleStatus($("#progress-cir-coffee"), 2);
        setCircleStatus($("#progress-cir-quantity"), 2);
        setCircleStatus($("#progress-cir-frequency"), 1);
        setCircleStatus($("#progress-cir-shipping"), 0);

        $("#subs-title").text("QUANTITY");
        $("#subs-subtitle").text("HOW MUCH WOULD YOU LIKE?");
        $("#subs-flick-back").show();

        break;
      case 3:
        setCircleStatus($("#progress-cir-coffee"), 2);
        setCircleStatus($("#progress-cir-quantity"), 2);
        setCircleStatus($("#progress-cir-frequency"), 2);
        setCircleStatus($("#progress-cir-shipping"), 1);

        $("#subs-title").text("FREQUENCY");
        $("#subs-subtitle").text("HOW OFTEN WOULD YOU LIKE DELIVERIES?");
        $("#subs-flick-back").show();



        break;
      case 4:
        setCircleStatus($("#progress-cir-coffee"), 2);
        setCircleStatus($("#progress-cir-quantity"), 2);
        setCircleStatus($("#progress-cir-frequency"), 2);
        setCircleStatus($("#progress-cir-shipping"), 2);

        $("#subs-title").text("CONFIRM");
        $("#subs-subtitle").text("YOUR SUBSCRIPTION SUMMARY");
        $("#wholebean-notice").css("display", "none");
        $("#faq-section").css("display", "none");
        $("#subs-flick-back").show();

        break;
      default:

    }

  });

  $("#subs-flick-back").on("click", function() {


    if ($("#options-slider").data("flickity").selectedIndex == 2) {

      if (coffeeType == "Capsule" || coffeeType == "Espresso") {
        $("#options-slider").flickity("selectCell", 0);

        return;
      }
    }

    $("#options-slider").flickity("previous");
  })



})
